import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {Permissions} from "./permissions";
import {TableModule} from "../magnament/generic/table/table.module";
import {PermissionsService} from "../../service/PermissionsService";


@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TableModule,
  ],
  providers: [PermissionsService],
  exports: [
    Permissions
  ],
  declarations: [Permissions]
})
export class PermissionsModule {}
